import { useI18n } from "@/i18n/I18nProvider";

type Props = { variant?: "unlicensed" | "spelpaus" | "general" };

export function RiskNotice({ variant = "general" }: Props) {
  const { t } = useI18n();
  const text =
    variant === "unlicensed"
      ? t("warning.unlicensed")
      : variant === "spelpaus"
        ? t("warning.utanSpelpaus")
        : t("responsible.notice");
  const colorClass =
    variant === "unlicensed"
      ? "border-amber-200 bg-amber-50 text-amber-900"
      : variant === "spelpaus"
        ? "border-rose-200 bg-rose-50 text-rose-900"
        : "border-ink-100 bg-ink-50 text-ink-700";
  return (
    <aside
      role="note"
      className={`rounded-xl border p-4 text-sm ${colorClass}`}
    >
      <strong className="mr-1">⚠️</strong>
      {text}
    </aside>
  );
}
